/*export const menu = require('./menu').default
export const breadcrumbs = require('./breadcrumbs').default*/
export const api = require('./api').default



// WEBPACK FOOTER //
// ./src/config/index.js